import React from 'react';
import { useTranslation } from 'react-i18next';
import Grid from '@/components/molecules/Grid';
import Button from '@/components/atoms/UI/buttons/Button';
import Icon from '@/components/atoms/UI/Icon/Icon';
import {
	WidgetPricingItemWrap,
	HeaderTitle,
	Price,
	Selected,
	WidgetHeader,
	DemoButton,
} from '@/components/features/widgets/WidgetPricingItem/styles';
import { WidgetPricingProps } from '@/store/types/widgetPricingTypes';
import { AccentTextL, TextS } from '@/pages/designSystem/Fonts';
import FlexContainer from '@/components/molecules/FlexContainer';
import Advantage from '@/components/atoms/Advatage/Advatage';

interface WidgetPricingItemProps extends WidgetPricingProps {
	onClick: () => void;
}

const WidgetPricingItem: React.FC<WidgetPricingItemProps> = ({ isPopup, selected, planType, price, features, demoUrl, onClick }) => {
	const { t } = useTranslation();
	const text_select = t('widget.select');
	const text_selected = t('widget.selected');
	const text_demo = t('widget.demo');

	return (
		<WidgetPricingItemWrap isPopup={isPopup} className={selected ? 'active' : ''} onClick={onClick}>
			<WidgetHeader gap={'2'} margin={'1'} stretchAutoWidth isActive={selected}>
				<Grid gap={'1'} col={'1'}>
					<HeaderTitle isActive={selected}><AccentTextL>{planType}</AccentTextL></HeaderTitle>
					<Price><TextS>{price}</TextS></Price>
				</Grid>

				{isPopup && (
					<div>
						{selected ?
							<FlexContainer><Icon name={'Check'} xSmall /><Selected>{text_selected}</Selected></FlexContainer> :
							<Button small autoWidth>{text_select}</Button>}
					</div>
				)}
			</WidgetHeader>

			{selected && <>
				<Grid col={'1'} gap={'1'} margin={'2'}>
					{features.map((feature, index) => (
						<Advantage key={index} special={feature.special} name={feature.name}/>
					))}
				</Grid>
				<DemoButton href={demoUrl} target="_blank" isActive={selected}>
					<Button link small><Icon name='Open' xSmall/>{text_demo}</Button>
				</DemoButton>
			</>}

		</WidgetPricingItemWrap>
	);
};

export default WidgetPricingItem;
